import { NodeViewWrapper, NodeViewContent } from '@tiptap/react';
import styles from './HiddenBlockView.module.css';

// HiddenBlockView — React NodeView for hiddenBlock. Owner/admin (the only
// roles that ever see this UI, since lower roles get a HiddenPlaceholder via
// server-side strip) can toggle which lower roles receive the body.
//
// Visibility roles are stored on `node.attrs.visible` as a string[] subset of
// ['editor', 'viewer']. Empty = only owner+admin. When non-empty, the wrapper
// flips color (magenta → green) to signal "shared".
const ROLES = ['editor', 'viewer'];

export default function HiddenBlockView({ node, updateAttributes }) {
  const visible = Array.isArray(node.attrs.visible) ? node.attrs.visible : [];
  const isShared = visible.length > 0;

  // Visibility is hierarchical: viewer cannot exceed editor's access. So
  // enabling viewer auto-enables editor; disabling editor auto-disables
  // viewer. Toggling viewer alone in the "off" direction is allowed.
  const toggle = (role) => {
    const has = (r) => visible.includes(r);
    let next = visible.slice();
    if (role === 'viewer') {
      if (has('viewer')) {
        next = next.filter((r) => r !== 'viewer');
      } else {
        next = Array.from(new Set([...next, 'viewer', 'editor']));
      }
    } else {
      if (has('editor')) {
        next = next.filter((r) => r !== 'editor' && r !== 'viewer');
      } else {
        next = Array.from(new Set([...next, 'editor']));
      }
    }
    updateAttributes({ visible: next });
  };

  const label = isShared
    ? `HIDDEN · shared with ${visible.join(', ')}`
    : 'HIDDEN · owner/admin only';

  return (
    <NodeViewWrapper className={`${styles.wrapper} ${isShared ? styles.shared : ''}`}>
      <div className={styles.toolbar} contentEditable={false}>
        <span className={styles.label}>{label}</span>
        <span className={styles.visGroup}>
          visible to:
          {ROLES.map((r) => (
            <label key={r} className={styles.check}>
              <input
                type="checkbox"
                checked={visible.includes(r)}
                onChange={() => toggle(r)}
              />
              {r}
            </label>
          ))}
        </span>
      </div>
      <NodeViewContent className={styles.body} />
    </NodeViewWrapper>
  );
}
